import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { RequestDTO } from '../../dtos/request-dto';
import { ResponseDTO } from '../../dtos/response-dto';
import { AbstractServicePublic } from '../../service/abstract.service.public';


@Injectable({ providedIn: 'root' })
export class AuthenticationService extends AbstractServicePublic {

  private currentUserSubject: BehaviorSubject<ResponseDTO>;

  public currentUser: Observable<ResponseDTO>;

  constructor(http: HttpClient, private router: Router,
    private route: ActivatedRoute) {

    super(http);

    this.currentUserSubject = new BehaviorSubject<ResponseDTO>(JSON.parse(localStorage.getItem('currentUser') || '{}'));

    this.currentUser = this.currentUserSubject.asObservable();
  }

  protected getBaseUrlPublic(): string {
    return super.getBaseUrlPublic() + 'authenticate';
  }

  public get currentUserValue(): ResponseDTO {
    return this.currentUserSubject.getValue();
  }

  createAuthentication(entity: Object): Observable<Object> {
    return this.http.post(`${this.getBaseUrlPublic()}`, entity);
  }

  login(username: string, password: string) {

    let request: RequestDTO = new RequestDTO(username, password);

    this.createAuthentication(request).subscribe(data => {
      localStorage.setItem('currentUser', JSON.stringify(data));
      this.currentUserSubject.next(data as ResponseDTO);

      // get return url from route parameters or default to '/home'
      let returnUrl: String = this.route.snapshot.queryParams['returnUrl'] || '';

      this.router.navigate([returnUrl]).then(() => {
        window.location.reload();
      });
    }, error => {
      console.log(error);
    });

  }

  logout() {
    localStorage.removeItem('currentUser');
    this.currentUserSubject.next(new ResponseDTO(null, null,null));
    this.router.navigate(['login']).then(() => {
      window.location.reload();
    });
}

  getUserName(): string {
    return JSON.parse(localStorage.getItem('currentUser') || '{}').username;
  }
}
